export const APP_BASE_URL =
  process.env.NEXT_PUBLIC_NODE_STAGE === "prod"
    ? "https://app.finzypay.io"
    : "https://app-finzypay.qubicat.ru";
